import { Flatfile } from "@flatfile/api";

export const stripeSheetConfig: Flatfile.SheetConfig = {
  name: "Stripe data",
  description: "Import Stripe data",
  slug: "stripeDataSheet",
  fields: [
    {
      key: "stripeCustomerId",
      type: "string",
      label: "Stripe Customer ID",
      constraints: [
        {
          type: "required",
        },
      ],
      alternativeNames: [
        "customer_id_new",
        "Stripe Customer ID",
        "id",
        "customer_id",
        "created_customer",
      ],
    },
  ],
};
